import {
  Box,
  Button,
  chakra,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  Textarea,
} from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { messageTemplateVariables } from 'ai-constants'
import React, { useCallback, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { GoLinkExternal } from 'react-icons/go'
import { MdAddCircleOutline } from 'react-icons/md'
import { TransitionAllStyles } from '../constants/prebuild-styles'
import {
  DeliveryChannel,
  IMessageTemplate,
  MessageTemplateCtx,
} from '../providers/MessageTemplate.provider'
import {
  IMessageTemplateSchema,
  MessageTemplateSchema,
} from '../schemas/message-template.schema'
import { TranslatorOnlyString } from './Translator'

interface IMessage {
  footer?: string | null | undefined
  body: string
  subject: string
}

const EmailPreview = (props: IMessageTemplateSchema) => {
  return (
    <table
      role='presentation'
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: 0,
        borderSpacing: 0,
        background: '#eaf0f6',
      }}
    >
      <tbody>
        <tr>
          <td
            className='external-container'
            align='center'
            valign='top'
            style={{ padding: '20px 20px' }}
          >
            <table
              role='presentation'
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                borderSpacing: 0,
                background: '#ffffff',
              }}
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align='center'>
                    <table
                      className='container'
                      width='100%'
                      style={{ padding: '0 30px' }}
                      border={0}
                      cellSpacing={0}
                      cellPadding={0}
                    >
                      <tbody>
                        <tr>
                          <td
                            className='td'
                            style={{
                              fontSize: '0pt',
                              lineHeight: '0pt',
                              padding: '10px',
                              margin: 0,
                              fontWeight: 'normal',
                            }}
                          >
                            <table
                              width='100%'
                              border={0}
                              cellSpacing={0}
                              cellPadding={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className='p30-15 tbrr'
                                    style={{
                                      padding: '30px 0px 10px 0px',
                                      borderRadius: '12px 12px 0px 0px',
                                    }}
                                  >
                                    <table
                                      width='100%'
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <th
                                            style={{
                                              width: 145,
                                              fontSize: '0pt',
                                              lineHeight: '0pt',
                                              padding: 0,
                                              margin: 0,
                                              fontWeight: 'normal',
                                              verticalAlign: 'top',
                                            }}
                                          >
                                            <table
                                              width='100%'
                                              border={0}
                                              cellSpacing={0}
                                              cellPadding={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    className='img'
                                                    style={{
                                                      fontSize: '0pt',
                                                      lineHeight: '0pt',
                                                      textAlign: 'left',
                                                      paddingRight: '8px',
                                                    }}
                                                  >
                                                    <img
                                                      src={
                                                        props.logo ||
                                                        '/assets/icon-192x192.png'
                                                      }
                                                      alt='Logo'
                                                      style={{
                                                        width: 100,
                                                        height: 40,
                                                        display: 'block',
                                                        objectFit: 'contain',
                                                      }}
                                                    />
                                                  </td>
                                                  <td
                                                    className='ai-hashtag'
                                                    align='right'
                                                    style={{
                                                      color: '#838586',
                                                      fontFamily:
                                                        'Helvetica, sans-serif',
                                                      fontSize: '14px',
                                                      lineHeight: '18px',
                                                      fontWeight: 'bold',
                                                      fontStyle: 'italic',
                                                      textAlign: 'right',
                                                      paddingBottom: '9px',
                                                    }}
                                                  >
                                                    #TecnoParaVos
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </th>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <table
                              width='100%'
                              border={0}
                              cellSpacing={0}
                              cellPadding={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className='p30-15'
                                    style={{ padding: '40px 0px 40px 0px' }}
                                  >
                                    <table
                                      width='100%'
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            className='h3 pb15'
                                            style={{
                                              color: '#23496d',
                                              fontFamily: 'Roboto, sans-serif',
                                              fontSize: '24px',
                                              lineHeight: '32px',
                                              textAlign: 'left',
                                              paddingBottom: '10px',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            {props.subject}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            className='text pb15'
                                            style={{
                                              color: '#23496d',
                                              fontFamily: 'Roboto, sans-serif',
                                              fontSize: '18px',
                                              lineHeight: '28px',
                                              textAlign: 'left',
                                              paddingBottom: '15px',
                                            }}
                                            dangerouslySetInnerHTML={{
                                              __html: props.body.replaceAll(
                                                '\n',
                                                '<br/>',
                                              ),
                                            }}
                                          />
                                        </tr>
                                        <tr>
                                          <td
                                            style={{ padding: '40px 0' }}
                                            align='center'
                                          >
                                            <table
                                              role='presentation'
                                              style={{
                                                width: '100%',
                                                borderCollapse: 'collapse',
                                                border: 0,
                                                borderSpacing: 0,
                                                fontSize: '9px',
                                                fontFamily: 'Roboto,sans-serif',
                                              }}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{ padding: 0 }}
                                                    align='center'
                                                  >
                                                    <p
                                                      style={{
                                                        margin: 0,
                                                        lineHeight: '16px',
                                                        fontFamily:
                                                          'Roboto,sans-serif',
                                                        color: '#ffffff',
                                                        textAlign: 'center',
                                                      }}
                                                    >
                                                      <a
                                                        target='_blank'
                                                        style={{
                                                          padding: '12px 25px',
                                                          borderRadius: '4px',
                                                          fontSize: '16px',
                                                          fontWeight: 600,
                                                          color:
                                                            '#ffffff !important',
                                                          textDecoration:
                                                            'none',
                                                          background: '#23496d',
                                                        }}
                                                      >
                                                        {props.buttonLabel}
                                                      </a>
                                                    </p>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    align='center'
                                    className='h3 pb15'
                                    style={{
                                      color: '#23496d',
                                      fontFamily: 'Roboto, sans-serif',
                                      fontSize: '12px',
                                      lineHeight: '32px',
                                      textAlign: 'center',
                                      paddingBottom: 0,
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    Powered by
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    align='center'
                                    className='img'
                                    style={{
                                      fontSize: '0pt',
                                      lineHeight: '0pt',
                                      textAlign: 'center',
                                      paddingBottom: '40px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <img
                                        style={{ objectFit: 'contain' }}
                                        src='https://ai-web-assets.s3.amazonaws.com/logo-primary.png'
                                        width={100}
                                        height={100}
                                        alt=''
                                      />
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    height={1}
                                    className='img'
                                    style={{
                                      fontSize: '0pt',
                                      lineHeight: '0pt',
                                      textAlign: 'left',
                                    }}
                                  >
                                    &nbsp;
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className='pb40'
                                    style={{ paddingBottom: '40px' }}
                                  />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

const SMSPreview = (props: IMessage) => {
  return (
    <div className='container'>
      <style
        //@ts-ignore
        jsx={true}
        global
      >
        {`
          .container {
            padding: 10px;
          }

          .message-blue {
            position: relative;
            margin-left: 20px;
            margin-bottom: 20px;
            padding: 10px;
            padding-bottom: 25px;
            background-color: #a8ddfd;
            width: 300px;
            text-align: left;
            font: 400 0.9em 'Open Sans', sans-serif;
            border: 1px solid #97c6e3;
            border-radius: 10px;
          }

          .message-orange {
            position: relative;
            margin-bottom: 10px;
            margin-left: calc(100% - 240px);
            padding: 10px;
            background-color: #f8e896;
            width: 200px;
            height: 50px;
            text-align: left;
            font: 400 0.9em 'Open Sans', sans-serif;
            border: 1px solid #dfd087;
            border-radius: 10px;
          }

          .message-content {
            padding: 0;
            margin: 0;
          }

          .message-timestamp-right {
            position: absolute;
            font-size: 0.85em;
            font-weight: 300;
            bottom: 5px;
            right: 5px;
          }

          .message-timestamp-left {
            position: absolute;
            font-size: 0.85em;
            font-weight: 300;
            bottom: 5px;
            left: 5px;
          }

          .message-blue:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-top: 15px solid #a8ddfd;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            top: 0;
            left: -15px;
          }

          .message-blue:before {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-top: 17px solid #97c6e3;
            border-left: 16px solid transparent;
            border-right: 16px solid transparent;
            top: -1px;
            left: -17px;
          }

          .message-orange:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-bottom: 15px solid #f8e896;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            bottom: 0;
            right: -15px;
          }

          .message-orange:before {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-bottom: 17px solid #dfd087;
            border-left: 16px solid transparent;
            border-right: 16px solid transparent;
            bottom: -1px;
            right: -17px;
          }
        `}
      </style>
      <Box pos='relative' w='full' className='message-blue'>
        <p className='message-content'>{props.subject}</p>
        <p className='message-content'>{props.body}</p>
        <p className='message-content'>
          https://app.autoinspector.com.ar/63971f5639ba1e1ca05e1e1c?accessCode=1234
        </p>
        <br />
        <Box right={2} bottom={2} pos='absolute'>
          <Text>SMS 13:37</Text>
        </Box>
      </Box>
    </div>
  )
}

const WhatsappPreview = (props: IMessage) => {
  return (
    <div className='page'>
      <style
        //@ts-ignore
        global={true}
        jsx
      >
        {`
          .page {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .screen {
            height: 20rem;
          }

          .marvel-device .screen {
            text-align: left;
          }

          .screen-container {
            height: 100%;
          }

          .status-bar {
            height: 25px;
            background: #004e45;
            color: #fff;
            font-size: 14px;
            padding: 0 8px;
          }

          .status-bar:after {
            content: '';
            display: table;
            clear: both;
          }

          .status-bar div {
            float: right;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            margin: 0 0 0 8px;
            font-weight: 600;
          }

          /* Chat */

          .chat {
            height: calc(100% - 69px);
          }

          .chat-container {
            height: 100%;
          }

          /* User Bar */

          .user-bar {
            height: 55px;
            background: #005e54;
            color: #fff;
            padding: 0 8px;
            font-size: 24px;
            position: relative;
            z-index: 1;
          }

          .user-bar:after {
            content: '';
            display: table;
            clear: both;
          }

          .user-bar div {
            float: left;
            transform: translateY(-50%);
            position: relative;
            top: 50%;
          }

          .user-bar .actions {
            float: right;
            margin: 0 0 0 20px;
          }

          .user-bar .actions.more {
            margin: 0 12px 0 32px;
          }

          .user-bar .actions.attachment {
            margin: 0 0 0 30px;
          }

          .user-bar .actions.attachment i {
            display: block;
            transform: rotate(-45deg);
          }

          .user-bar .avatar {
            margin: 0 0 0 5px;
            width: 36px;
            height: 36px;
          }

          .user-bar .avatar img {
            border-radius: 50%;
            box-shadow: 0 1px 0 rgba(255, 255, 255, 0.1);
            display: block;
            width: 100%;
          }

          .user-bar .name {
            font-size: 17px;
            font-weight: 600;
            letter-spacing: 0.3px;
            margin: 0 0 0 8px;
            overflow: hidden;
            white-space: nowrap;
            width: 200px;
          }

          .user-bar .status {
            display: block;
            font-size: 13px;
            font-weight: 400;
            letter-spacing: 0;
          }

          .conversation {
            height: calc(100% - 12px);
            position: relative;
            background: #efe7dd url('/assets/wsp-bg.jpg') repeat;
            z-index: 0;
          }

          .conversation .conversation-container {
            height: calc(100% - 68px);
            box-shadow: inset 0 10px 10px -10px #000000;
            padding: 0 16px;
            margin-bottom: 5px;
          }

          .conversation .conversation-container:after {
            content: '';
            display: table;
            clear: both;
          }

          /* Messages */

          .message {
            color: #000;
            clear: both;
            line-height: 18px;
            font-size: 15px;
            padding: 8px;
            position: relative;
            margin: 8px 0;
            max-width: 85%;
            word-wrap: break-word;
            z-index: -1;
          }

          .message:after {
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
          }

          .metadata {
            display: inline-block;
            float: right;
            padding: 0 0 0 7px;
            position: relative;
            bottom: -4px;
          }

          .metadata .time {
            color: rgba(0, 0, 0, 0.45);
            font-size: 11px;
            display: inline-block;
          }

          .metadata .tick {
            display: inline-block;
            margin-left: 2px;
            position: relative;
            top: 4px;
            height: 16px;
            width: 16px;
          }

          .metadata .tick svg {
            position: absolute;
            transition: 0.5s ease-in-out;
          }

          .metadata .tick svg:first-child {
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transform: perspective(800px) rotateY(180deg);
            transform: perspective(800px) rotateY(180deg);
          }

          .metadata .tick svg:last-child {
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transform: perspective(800px) rotateY(0deg);
            transform: perspective(800px) rotateY(0deg);
          }

          .metadata .tick-animation svg:first-child {
            -webkit-transform: perspective(800px) rotateY(0);
            transform: perspective(800px) rotateY(0);
          }

          .metadata .tick-animation svg:last-child {
            -webkit-transform: perspective(800px) rotateY(-179.9deg);
            transform: perspective(800px) rotateY(-179.9deg);
          }

          .message:first-child {
            margin: 16px 0 8px;
          }

          .message.received {
            background: #fff;
            border-radius: 0px 5px 5px 5px;
            float: left;
          }

          .message.received .metadata {
            padding: 0 0 0 16px;
          }

          .message.received:after {
            border-width: 0px 10px 10px 0;
            border-color: transparent #fff transparent transparent;
            top: 0;
            left: -10px;
          }

          .message.sent {
            background: #e1ffc7;
            border-radius: 5px 0px 5px 5px;
            float: right;
          }

          .message.sent:after {
            border-width: 0px 0 10px 10px;
            border-color: transparent transparent transparent #e1ffc7;
            top: 0;
            right: -10px;
          }

          /* Compose */

          .conversation-compose {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            overflow: hidden;
            height: 50px;
            width: 100%;
            z-index: 2;
          }

          .conversation-compose div,
          .conversation-compose input {
            background: #fff;
            height: 100%;
          }

          .conversation-compose .emoji {
            display: flex;
            align-items: center;
            justify-content: center;
            background: white;
            border-radius: 5px 0 0 5px;
            flex: 0 0 auto;
            margin-left: 8px;
            width: 48px;
          }

          .conversation-compose .input-msg {
            border: 0;
            flex: 1 1 auto;
            font-size: 16px;
            margin: 0;
            outline: none;
            min-width: 50px;
          }

          .conversation-compose .photo {
            flex: 0 0 auto;
            border-radius: 0 0 5px 0;
            text-align: center;
            position: relative;
            width: 48px;
          }

          .conversation-compose .photo:after {
            border-width: 0px 0 10px 10px;
            border-color: transparent transparent transparent #fff;
            border-style: solid;
            position: absolute;
            width: 0;
            height: 0;
            content: '';
            top: 0;
            right: -10px;
          }

          .conversation-compose .photo i {
            display: block;
            color: #7d8488;
            font-size: 24px;
            transform: translate(-50%, -50%);
            position: relative;
            top: 50%;
            left: 50%;
          }

          .conversation-compose .send {
            background: transparent;
            border: 0;
            cursor: pointer;
            flex: 0 0 auto;
            margin-left: 8px;
            margin-right: 8px;
            padding: 0;
            position: relative;
            outline: none;
          }

          .conversation-compose .send .circle {
            background: #008a7c;
            border-radius: 50%;
            color: #fff;
            position: relative;
            width: 48px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .conversation-compose .send .circle i {
            font-size: 24px;
            margin-left: 5px;
          }

          /* Small Screens */

          @media (max-width: 768px) {
            .marvel-device.nexus5 {
              border-radius: 0;
              flex: none;
              padding: 0;
              max-width: none;
              overflow: hidden;
              height: 100%;
              width: 100%;
            }

            .marvel-device > .screen .chat {
              visibility: visible;
            }

            .marvel-device {
              visibility: hidden;
            }

            .marvel-device .status-bar {
              display: none;
            }

            .screen-container {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }

            .conversation {
              height: calc(100vh - 55px);
            }
            .conversation .conversation-container {
              height: calc(100vh - 120px);
            }
          }
        `}
      </style>
      <Box w='full' className='marvel-device nexus5'>
        <div className='top-bar'></div>
        <div className='sleep'></div>
        <div className='volume'></div>
        <div className='camera'></div>
        <div className='screen'>
          <div className='screen-container'>
            <div className='status-bar'>
              <div className='time'></div>
              <div className='battery'>
                <i className='zmdi zmdi-battery'></i>
              </div>
              <div className='network'>
                <i className='zmdi zmdi-network'></i>
              </div>
              <div className='wifi'>
                <i className='zmdi zmdi-wifi-alt-2'></i>
              </div>
              <div className='star'>
                <i className='zmdi zmdi-star'></i>
              </div>
            </div>
            <div className='chat'>
              <div className='chat-container'>
                <div className='user-bar'>
                  <div className='back'>
                    <i className='zmdi zmdi-arrow-left'></i>
                  </div>
                  <div className='avatar'>
                    <img src='/assets/images/icon-1024x1024.png' alt='Avatar' />
                  </div>
                  <div className='name'>
                    <span>Autoinspector</span>
                    <span className='status'>online</span>
                  </div>
                  <div className='actions more'>
                    <i className='zmdi zmdi-more-vert'></i>
                  </div>
                  <div className='actions attachment'>
                    <i className='zmdi zmdi-attachment-alt'></i>
                  </div>
                  <div className='actions'>
                    <i className='zmdi zmdi-phone'></i>
                  </div>
                </div>
                <div className='conversation'>
                  <div className='conversation-container'>
                    <div className='message received'>
                      <strong>{props.subject}</strong>
                      <br />
                      {props.body}
                      <Box>
                        <Text color='gray.400'>{props.footer}</Text>
                      </Box>
                      <Box>
                        <chakra.hr my='2' />
                        <Box
                          display={'flex'}
                          alignItems='center'
                          textAlign={'center'}
                          justifyContent='center'
                        >
                          <GoLinkExternal color='#34B7F1' />
                          <Text color={'#34B7F1'} ml='1'>
                            Ir al a inspección
                          </Text>
                        </Box>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </div>
  )
}

export const MessageTemplatePreview = ({
  fields,
  channel,
}: {
  fields: IMessageTemplateSchema
  channel: DeliveryChannel
}) => {
  switch (channel) {
    case 'wsp':
      return <WhatsappPreview {...fields} />

    case 'sms':
      return <SMSPreview {...fields} />

    case 'email':
      return <EmailPreview {...fields} />

    default:
      return null
  }
}
